import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TrendArrowupIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7 7H17V17L15.2036 16.9701L15.2186 10.009L7.61377 17.6138L6.38623 16.3862L13.991 8.78144L7 8.76647L7 7Z'
                fill='currentColor'
            />
        </>
    ),
})

TrendArrowupIcon.displayName = 'TrendArrowupIcon'
